import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useTablesContext } from "../../../../context/tablesContextProvider";
import { MyMedicalPaOrdersTableData } from "../../../../data-model/tablesData";
import { TableNames } from "../../../../enums/tableNames";
import { RootState } from "../../../../redux/store/store";
import { getOrgIdForFetchExternalWorklist } from "../../../../utils/organizationHelper";
import { makePostCallForInitialDataFetch } from "../apis/makePostCallForInitialDataFetch";
import { generateFilterPayloadForMyPaOrders } from "../utils/generateFilterPayloadForMyPaOrders";
import { recursivelyGeneratePayloadForInitialFetch } from "../utils/recursivelyGeneratePayloadForInitialFetch";
import { MyMedicalPaOrdersState } from "./useMyPaOrdersTableData";
import { useValidFilters } from "./useValidFilters";

export const useInitialDataFetchingForTable = (
  setMyMedicalPaOrdersState: React.Dispatch<
    React.SetStateAction<MyMedicalPaOrdersState>
  >,
  setTableData: React.Dispatch<
    React.SetStateAction<MyMedicalPaOrdersTableData[]>
  >,
) => {
  const { data: authStatusOptions } = useSelector(
    (state: RootState) => state.authStatusOptions,
  );
  const { user } = useSelector(
    (state: RootState) => state.firebaseAuthentication,
  );
  const [initialDataFetchingExecuted, setInitialDataFetchingExecuted] =
    useState(false);

  const orgId = getOrgIdForFetchExternalWorklist();

  const { getTableDataFromContext } = useTablesContext();

  const tableAttributes = getTableDataFromContext(
    TableNames.MY_PA_ORDERS_FROM_ALGOLIA,
  );

  const validFilters = useValidFilters();

  useEffect(() => {
    if (
      !initialDataFetchingExecuted &&
      authStatusOptions &&
      authStatusOptions.length > 0
    ) {
      const payload = generateFilterPayloadForMyPaOrders(
        validFilters,
        tableAttributes?.searchedText ?? "",
        orgId,
        user?.id ?? "",
      );
      const payloads = recursivelyGeneratePayloadForInitialFetch(
        payload,
        tableAttributes?.lastBatchFetched ?? 0,
      );

      makePostCallForInitialDataFetch(
        payloads,
        authStatusOptions,
        setMyMedicalPaOrdersState,
        setTableData,
        setInitialDataFetchingExecuted,
      );
    }
  }, [authStatusOptions, initialDataFetchingExecuted]);

  return {
    initialDataFetchingExecuted,
    setInitialDataFetchingExecuted,
  };
};
